import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-add-animal-vaccine',
  templateUrl: './add-animal-vaccine.component.html',
  styleUrls: ['./add-animal-vaccine.component.css']
})
export class AddAnimalVaccineComponent implements OnInit {
  returnUrl = "/dashboard/RottweilerDogsAnimalmanagement";

  Formvalidation: FormGroup;

  vaccine_name: any;
  batch_no: any;
  dose_value: any;
  vaccine_date1: any;
  vaccine_date2: any;

  error_flag: boolean = false;

  addVaccineFormValue: any;
  addUrl: any;
  route: any;
  getlistApi: any;
  fragment: any;
  loginresponse: any;
  cby_mby: any;
  getVaccineListData: any;
  constructor(private router: Router, private commonService: CommonService, private formbuilder: FormBuilder) {

    this.Formvalidation = this.formbuilder.group({
      vaccine_name: ['', Validators.required],
      batch_no: ['', Validators.required],
      dose_value: ['', Validators.required],
      vaccine_date1: ['', Validators.required],
      vaccine_date2: ['', Validators.required]
    })

  }

  async ngOnInit() {
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby = this.loginresponse.user_id;
    $('.selectpicker').selectpicker('refresh');
    this.getlistApi = "/vaccine";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async (res) => {
        this.getVaccineListData = res.data;
      })
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 1500);

  }

  async AnimalVaccine() {

    if (!this.vaccine_name || !this.batch_no || !this.dose_value || !this.vaccine_date1 || !this.vaccine_date2) {
      if (!this.vaccine_name) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.batch_no) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.dose_value) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.vaccine_date1) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.vaccine_date2) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      return
    }


    var farmid = sessionStorage.getItem('farmid');
    var Animalid = sessionStorage.getItem('animalid');
    var speciesid = sessionStorage.getItem('speciesid');
    var breedid = sessionStorage.getItem('breedid');
    var ageid = sessionStorage.getItem('ageid');
    this.addVaccineFormValue = {
      "species_id": speciesid,
      "breed_id": breedid,
      "farm_id": farmid,
      "animal_code": Animalid,
      "vaccine_name": $("#vaccinename").val(),
      "batch_number": $("#batchNumber").val(),
      "expiry_date": $("#ExpiryDate").val(),
      "dose_value": $("#dosevalue").val(),
      "age_group": ageid,
      "units": $("#unit").val(),
      "date_of_first_vaccine": $("#VaccineDate1").val(),
      "date_of_second_vaccine": $("#VaccineDate2").val(),
      "cby": this.cby_mby,
      "status": 1,
      "is_active": 1
    };
    console.log(this.addVaccineFormValue)
    this.addUrl = "/animal_management/vaccine";
    (await this.commonService.postApi(this.addUrl, this.addVaccineFormValue)).subscribe(
      data => {
        alert("Data added successfully");
      });
    setTimeout(
      (): void => {

        this.router.navigate([this.returnUrl, { fragment: 'Vaccine' }]);

      },
      500
    );
    //}
  }

  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }
}
